import React from "react";
import InspectionShell from "../InspectionShell";
import SessionLoadingGraphic from "../SessionLoadingGraphic";
import "./style.css";

const STEPS = [
  { id: "status", label: "Checking photo status" },
  { id: "session", label: "Preparing capture session" },
];

export default function SessionLoadingScreen({ onBack }) {
  return (
    <InspectionShell
      badge="Car damages"
      mainClassName="pi-inspection-main--center pi-inspection-main--status"
      showFooter={false}
      className="pi-inspection-page--app"
      onBack={onBack}
    >
      <div className="pi-inspection-status-card pi-inspection-status-card--premium pi-inspection-status-card--loading">
        <p className="pi-inspection-label">Car damages</p>
        <div className="pi-inspection-status-card__hero pi-inspection-status-card__hero--loading">
          <SessionLoadingGraphic />
        </div>
        <div className="pi-status-progress" aria-hidden="true">
          <div className="pi-status-progress__track">
            <span className="pi-status-progress__fill" />
          </div>
          <ul className="pi-status-progress__steps">
            {STEPS.map((step, index) => (
              <li
                key={step.id}
                className={`pi-status-progress__step${
                  index === 0 ? " is-active" : ""
                }`}
              >
                <span className="pi-status-progress__dot" />
                <span>{step.label}</span>
              </li>
            ))}
          </ul>
        </div>
        <h1>Preparing your photo session</h1>
        <p>Please wait while we check existing vehicle photos.</p>
      </div>
    </InspectionShell>
  );
}
